import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pp-lottery-winnings" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { PpDraw } from "@/lotteries/services/model/draw";
import { StringUtils } from "@sazka/utils/string-utils";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import PpSpecialPrizeWinnings from "./pp-special-prize-winnings.vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-extra-renta-winnings',
  props: {
    results: {}
  },
  setup(__props: any) {



const formatAmount = (amount: number) => {
    return `${StringUtils.formatCurrency(amount)}&nbsp;/ ${StringUtils.formatCurrency(amount * 2)}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DsTable, null, {
      default: _withCtx(() => [
        _createVNode(DsRow, null, {
          default: _withCtx(() => [
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("Pořadí")
              ])),
              _: 1,
              __: [0]
            }),
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Výhra")
              ])),
              _: 1,
              __: [1]
            }),
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Uhodnuto")
              ])),
              _: 1,
              __: [2]
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.mainGameWinnings[0], (winning, index) => {
          return (_openBlock(), _createBlock(DsRow, { key: index }, {
            default: _withCtx(() => [
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(index + 1) + ". pořadí", 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  (winning.amount && winning.wins)
                    ? (_openBlock(), _createElementBlock("strong", {
                        key: 0,
                        innerHTML: formatAmount(winning.amount)
                      }, null, 8, _hoisted_2))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("–––")
                      ], 64))
                ]),
                _: 2
              }, 1024),
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  (winning.amount && winning.wins)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        innerHTML: _unref(StringUtils).formatNumber(winning.wins) + 'x'
                      }, null, 8, _hoisted_3))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("–––")
                      ], 64))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(PpSpecialPrizeWinnings, {
      lottery: _unref(Lottery).extraRenta,
      specialPrizes: _ctx.results.specialPrizes
    }, null, 8, ["lottery", "specialPrizes"])
  ]))
}
}

})